import React from 'react';
import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Provider} from "react-redux";
import store from "../storeWire";

function Chain(props) {
    return (
        <Provider store={store}>
            <ToastContainer/>
            <BrowserRouter>
                {props.children}
            </BrowserRouter>
        </Provider>
    );
}

export default Chain;
